export const generalHelpNumber = '844-442-6618';
export const technicalHelpNumber = '800-442-5502';
export const technicalHelpNumberCovidScreening = '385-297-6430';
export const patientFinancialServicesNumber = '866-415-6556';
export const selectHealthMemberServices = `800-538-5038`;
export enum MammogramPhoneNumbers {
  NorthSouth = '801-525-5700',
  CentralSouthwest = '801-507-7840',
  RuralSouth = '435-893-0514',
  BearRiver = '435-207-4545',
  Cassia = '208-677-6551'
}
export const invalidPhoneNumberPermissions =
  'Phone number is not available or app has not been granted permissions';
